// MUI imports
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

// Generic imports
import _ from 'lodash'
import countryCodes from 'country-codes-list';

// Local imports
import Autosuggest from 'react-autosuggest';

function AccountAutoSuggest(props) {
    const { error, suggestions, account, setAccount, onBlur } = props;
    return (
        <FormControl variant='outlined' fullWidth>

            <Autosuggest 
                suggestions={account?.name ? _(suggestions).filter(e => e?.name).filter(e => e.name.toLowerCase().startsWith((account.name || '').toLowerCase())).sortBy(a => a.name.trim().toLowerCase()).value().splice(0, 4) : []}
                focusInputOnSuggestionClick={false}
                onSuggestionsFetchRequested={() => {}}
                onSuggestionsClearRequested={() => {}}
                getSuggestionValue={(suggestion) => {
                    // Set the full account object when suggestion is selected
                    setAccount({ ...suggestion, email: account?.email || suggestion?.email });
                    return suggestion.name;
                }}
                shouldRenderSuggestions={() => true}
                renderSuggestionsContainer={(options) => (
                    <Paper {...options.containerProps} classes={{ root: 'registration-no-ul' }} sx={{ position: 'absolute', width: '100%' }} square>
                        {options.children}
                    </Paper>
                )}
                renderSuggestion={(suggestion, { query, isHighlighted }) => {
                    return (
                    <MenuItem selected={isHighlighted} component='div' sx={{ flexDirection: 'column', alignItems: 'start', justifyContent: 'start' }}>
                        <div style={{ textAlign: 'start' }}>
                            {suggestion.name}
                        </div>
                        <Typography variant='caption' color='textSecondary' component={Box}>
                            {suggestion.address ? countryCodeToCountry(suggestion.address.countryCode): ''}{suggestion.uniqueId && suggestion.address ? ' | ' : ''}{suggestion.uniqueId ? _.last(suggestion.uniqueId.split(':')) : ''}
                        </Typography>
                    </MenuItem>
                )}}
                value={account}
                renderInputComponent={renderInputComponent}
                inputProps={{
                    onBlur,
                    error: error,
                    label: 'Account Name',
                    id: 'account-name',
                    value: account.name || '',
                    onChange: (event: React.ChangeEvent<HTMLInputElement>) => { 
                        if (!_.isUndefined(event.target.value)) setAccount({ name: event.target.value, email: account?.email })
                    }
                }}
            />

        </FormControl>
    );
}

function renderInputComponent(inputProps) {
    const { classes, inputRef = () => {}, ref, ...other } = inputProps;
    return ( <TextField fullWidth label='Company' margin='normal' InputLabelProps={{ shrink: true }} inputprops={{ inputRef: (node) => { ref(node); inputRef(node); }, }} {...other} />); 
}

function countryCodeToCountry(code) {
    return (countryCodes.findOne('countryCode', code) || {}).countryNameEn || code;
}

export default AccountAutoSuggest;
